var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-widget-loader",attrs:{"data-testid":"home-widget-loader"}},_vm._l((_vm.rows),function(row,index){return _c('SkeletonLoader',{key:index,attrs:{"data-testid":"home-widget-loader-item"}},[_c('div',{staticClass:"home-widget-loader__row"})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }